<template>
  <div>


    <div class="price " :class="[
      { 'animate__animated animate__zoomOutLeft': isDeleting },
      { 'price--deleting': wasDeleted },

    ]">
      <div class="icon icon__chevron-down-green"
        v-if="price && price.price_companies && price.price_companies.length > 0 && canAccessCompanyPrices"
        :class="{ 'icon__chevron-down-green--active': expanded }" @click="expanded = !expanded"></div>
      <div class="column column--branch">
        <span>{{ price.branch_category.name }}</span>
      </div>
      <div class="column column--agent">
        <span @click="canEditPrice && (showPopupEditer = true)" :style="{ cursor: canEditPrice ? 'pointer' : 'not-allowed' }">
          <transition name="fade">
            <PopupEditer v-if="showPopupEditer" :selected="price.agent_provision * 100"
              @togglePopup="showPopupEditer = $event" @submit="changeAgentProvision($event)" />
          </transition>
          {{ (agentProvision * 100).toFixed(2) }}%
        </span>
      </div>
      <div class="column column--company">
        <span>{{ (price.company_provision * 100).toFixed(2) }}%</span>
      </div>
      <div class="icon icon__add" @click="addPriceCompany()" v-if="canCreateCompanyPrice">
      </div>
      <div v-if="canDeletePrice" class="icon icon__delete" @click="deletePrice()"></div>


    </div>
    <div class="company__prices__table" v-if="expanded">
      <PriceCompanyRow v-for="priceCompany in price.price_companies || []" :key="priceCompany.id" :priceCompany="priceCompany"
        :selectSale="selectSale" :teamId="teamId" :salesCategoryId="price.sales_category_id" :secondary="secondary" />
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from "vue";
import { useStore } from "vuex";
import PopupEditer from "@/partials/PopupEditer";
import PriceCompanyRow from "@/components/PriceCategories/PriceCompanyRow";

defineOptions({
  name: "PriceRow"
});

const props = defineProps({
  price: {
    required: true,
    type: Object,
  },
  selectSale: {
    required: true,
    type: Function,
  },
  teamId: {
    required: true,
    type: Number,
  },
  secondary: {
    type: Boolean,
    default: false,
  },
});

const store = useStore();

// State
const isDeleting = ref(false);
const wasDeleted = ref(false);
const expanded = ref(false);
const showPopupEditer = ref(false);
const agentProvision = ref("");
const agentProvisionCopy = ref("");

// Computed 
const isSuperAdmin = computed(() => store.getters.isSuperAdmin);
const canAccessCompanyPrices = computed(() => {
  if (isSuperAdmin.value) return true;
  return store.getters.hasTeamPermission("sales_category_price_access", props.teamId);
});
const canCreateCompanyPrice = computed(() => {
  if (isSuperAdmin.value) return true;
  return store.getters.hasTeamPermission("sales_category_price_create", props.teamId);
});
const canEditPrice = computed(() => {
  if (isSuperAdmin.value) return true;
  return store.getters.hasTeamPermission("sales_category_price_edit", props.teamId);
});
const canDeletePrice = computed(() => {
  if (isSuperAdmin.value) return true;
  return store.getters.hasTeamPermission("sales_category_price_delete", props.teamId);
});
const refreshCategories = () => store.dispatch(
  props.secondary ? "getSecondSaleCategoriesByTeam" : "getSaleCategoriesByTeam",
  props.teamId
);
//const priceCompaniesLength = computed(() => props.price.price_companies.length);

// Methods
const deletePrice = async () => {
  if (!canDeletePrice.value) return;
  isDeleting.value = true;
  await store.dispatch("deleteSaleCategoryPrice", { id: props.price.id, teamId: props.teamId });
  wasDeleted.value = true;

  setTimeout(async () => {
    await refreshCategories();
    props.selectSale(props.price.sales_category_id);
  }, 300);
};

const changeAgentProvision = async (provision) => {
  if (!canEditPrice.value) return;
  if (
    provision <= 100 &&
    provision >= 0 &&
    provision !== agentProvisionCopy.value
  ) {
    agentProvision.value = provision / 100;
    await store.dispatch("updateSaleCategoryPrice", {
      saleCategoryPriceId: props.price.id,
      provision,
      teamId: props.teamId,
    });

    await refreshCategories();
    props.selectSale(props.price.sales_category_id);
  }
};

const addPriceCompany = () => {
  if (!canCreateCompanyPrice.value) return;
  store.commit("setSaleCategoryPriceId", props.price.id);
  store.commit("setShowAddSaleCategoryCompanyModal", true);
};

// Lifecycle
onMounted(() => {
  agentProvision.value = props.price.agent_provision;
  agentProvisionCopy.value = props.price.agent_provision;
});
</script>

<style lang="scss" scoped>
span {
  color: var(--text-9);
}

.price {
  border-bottom: 1px solid var(--border-15);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 35px;
  padding-left: 20px;
  position: relative;
  max-height: 47px;
  transition: all 0.3s ease;

  &--deleting {
    padding: 0px 20px;
    max-height: 0px;
    overflow: hidden;
    border: 0;
  }

  .icon__chevron-down-green {
    left: 5px;

  }

  &--expanded {
    max-height: 500px;

  }

  .icon {
    position: absolute;
    right: 25px;
  }

  .icon__add {
    right: 60px;
  }


}

.company__prices__table {
  width: 100%;

}
</style>
